import clsx from 'clsx'
import { useEffect, useState } from 'react'

import { Source } from '../../models/Source'
import { Subaccount } from '../../models/Subaccount'
import { User } from '../../models/User'
import { Icon } from '../Icon'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'
import Tooltip from '../app/design/Tooltip'
import { ContactAvatar } from '../contacts/ContactAvatar'

type ClientProps = {
    user?: User
    subaccount?: Subaccount
    size?: 'xs' | 'sm'
    shouldShowCard?: boolean
}

export function ClientTableCell({
    user,
    subaccount,
    size = 'sm',
    shouldShowCard = false,
}: ClientProps) {
    const [showCard, setShowCard] = useState(false)
    const primaryText = subaccount?.name ?? user?.name
    const secondaryText = subaccount !== undefined ? user?.name : undefined

    useEffect(() => {
        const fetchValidSources = async (id: string) => {
            setShowCard((await Source.validClientSources(id)).length > 0)
        }
        if (shouldShowCard) {
            fetchValidSources(user?.id ?? '')
        }
    }, [shouldShowCard, user?.id])

    return (
        <div className={clsx('flex items-center gap-4', size === 'xs' && 'gap-3')}>
            <ContactAvatar user={subaccount ?? user ?? new User()} size={size} />
            <div className="flex cursor-pointer items-center justify-start gap-x-1">
                {size === 'sm' ? (
                    <>
                        <Label
                            size={size}
                            className={clsx(
                                subaccount !== undefined && 'max-w-[220px] shrink truncate'
                            )}
                        >
                            {primaryText}
                        </Label>
                        {secondaryText !== undefined && (
                            <Paragraph
                                size="sm"
                                className="shrink-0 font-light whitespace-nowrap text-gray-500"
                            >
                                {secondaryText}
                            </Paragraph>
                        )}
                    </>
                ) : (
                    <>
                        <Paragraph
                            size="sm"
                            className={clsx(
                                subaccount !== undefined && 'max-w-[220px] shrink truncate'
                            )}
                        >
                            {primaryText}
                        </Paragraph>
                        {secondaryText !== undefined && (
                            <Paragraph
                                size="sm"
                                className="shrink-0 font-light whitespace-nowrap text-gray-500"
                            >
                                {secondaryText}
                            </Paragraph>
                        )}
                    </>
                )}
                {showCard && (
                    <Tooltip label="Card on file">
                        <Icon icon="bankCard.medium" className="ml-2 shrink-0" />
                    </Tooltip>
                )}
            </div>
        </div>
    )
}
